<main class="landing">
  <div class="landing__parallax-zone">
    <div class="landing__particles" aria-hidden="true">
      @for (slot of particleSlots; track slot) {
        <span class="landing__particle"></span>
      }
    </div>
    <app-hero />
    <app-about />
    <app-event-carousel />
  </div>
  <app-budget-cta />
  <app-footer />
</main>
